import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TableRow, Table, TableHead, TableBody, TableCell, TableContainer, Paper } from "@material-ui/core";
import TrainerRegistrationService from "./Locality/Service/trainerRegistrationService";
import * as Yup from 'yup';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { Grid, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';

import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1a1a1aad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function Trainer() {
    const tableHeaders = ['Profile', ' Name', 'Mobile', 'Email', 'Edit', 'Delete'];
    const classes = useStyles();
    const [trainerRegistrationList, setTrainerRegistrationList] = useState([]);
    const [age, setAge] = React.useState('');
    const [trainerIdList, setTrainerIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [imageslist, setImagesList] = useState([]);
    const [imageslist1, setImagesList1] = useState([]);
    const [imageslist2, setImagesList2] = useState([]);

    var [classId, setClassId] = useState("");

    const [message, setMessage] = useState("");
    const [message1, setMessage1] = useState("");
    const [message2, setMessage2] = useState("");

    const [images, setImages] = useState([]);
    const [images1, setImages1] = useState([]);
    const [images2, setImages2] = useState([]);

    const [trainerRegistration, setTrainerRegistration] = useState({
        name: '',
        // subject: '',
        mobileNumber: '',
        // imageURL: '',
        // profileURL: '',
        // profile: '',
        // date: '',
        // classId: '',
        email: "",
        // status: '',
    })

    var [searchClassId, setSearchClassId] = useState("");

    const [isEditMode, setIsEditMode] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [addClassList, setAddClassList] = useState([]);
    const validationSchema = Yup.object().shape({
        name: Yup.string().required(' Name is required'),
        // classId: Yup.string().required('class is required'),
        email: Yup.string(),
        // subject: Yup.string().required(' required'),
        // status: Yup.string().required(' required'),
        // date: Yup.string(),

        mobileNumber: Yup.string().nullable(),
    });
    useEffect(() => {
        getTrainerRegistrationList();

        return () => {
            setTrainerRegistrationList([]);
        }
    }, []);
    const handleOpen = (status) => {
        if (status) {
            setTrainerRegistration({
                name: '',
                // subject: '',
                mobileNumber: '',

                // date: '',
                // classId: '',
                email: "",
                // status: '',
            })
            // Clear profile images when opening new dialog
            setImagesList2([]);
        }

        setOpen(true);
    };
    const verifyeetnt = () => {
        console.log(formik)
    }
    const handleClose = () => {
        setOpen(false);
        setIsEditMode(false);
        // Clear profile images when closing dialog
        setImagesList2([]);
    };
    const handleFileChange = (e) => {
        setImages(e.target.files); // Store all selected files in state
    };
    const handleFileChange1 = (e) => {
        setImages1(e.target.files); // Store all selected files in state
    };
    const handleFileChange2 = (e) => {
        setImages2(e.target.files); // Store all selected files in state
    };
    const handleClickShowPassword = () => {
        setShowPassword((prev) => !prev);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };


    const getTrainerRegistrationList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        TrainerRegistrationService.getAllTrainerRegistration().then((res) => {
            const mapResult = res.map((trainerRegistration) => {
                return { ...trainerRegistration }
            })
            setTrainerRegistrationList(mapResult);

        }).catch((err) => {
            // setError(err.message);
        });
    }
    const onSubmit = data => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));

        const keys = {
            'classId': searchClassId,
        }
        TrainerRegistrationService.findTrainerRegistrationList(keys).then((res) => {

            const mapResult = res.map((trainerRegistration) => {
                return { ...trainerRegistration }
            })
            setTrainerRegistrationList(mapResult);
            // setStudentList(res);
        }).catch((err) => {
            console.error(err)
            // setError(err.message);
        });

    };

    const editTrainerRegistration = (trainerregistration) => {
        setTrainerRegistration(trainerregistration);
        // Populate profile image if it exists
        if (trainerregistration.profile) {
            setImagesList2([trainerregistration.profile]);
        } else {
            setImagesList2([]);
        }
        handleOpen(false);
        setIsEditMode(true)
    };

    const deleteTrainerRegistration = (trainerregistrationdelete) => {
        if (trainerregistrationdelete) {
            TrainerRegistrationService.deleteTrainerRegistration(trainerregistrationdelete).then((res) => {
                getTrainerRegistrationList();
            }).catch((err) => {
            });
        }
    };
    const handleUpload = async (e) => {
        e.preventDefault();

        if (images.length === 0) {
            setMessage("Please select images first.");
            return;
        }
        try {
            const uploadedUrls = [];

            for (const image of images) {
                const formData = new FormData();
                formData.append("image", image);
                formData.append("imageName", image.name);

                const res = await TrainerRegistrationService.uploadImage(formData);
                uploadedUrls.push(res.url); // Assuming response contains the uploaded URL
            }
            setImagesList((prev) => [...prev, ...uploadedUrls]); // Add to array
            alert(" uploaded successfully");
        } catch (error) {
            console.error("Error uploading images:", error);
            setMessage1("An error occurred while uploading the images.");
        }


    };
    const handleUpload1 = async (e) => {
        e.preventDefault();

        if (images1.length === 0) {
            setMessage1("Please select images first.");
            return;
        }
        try {
            const uploadedUrls = [];

            for (const image of images1) {
                const formData = new FormData();
                formData.append("image", image);
                formData.append("imageName", image.name);

                const res = await TrainerRegistrationService.uploadImage(formData);
                uploadedUrls.push(res.url); // Assuming response contains the uploaded URL
            }
            setImagesList1((prev) => [...prev, ...uploadedUrls]); // Add to array
            alert(" uploaded successfully");
        } catch (error) {
            console.error("Error uploading images:", error);
            setMessage1("An error occurred while uploading the images.");
        }


    };
    const handleUpload2 = async (e) => {
        e.preventDefault();

        if (images2.length === 0) {
            setMessage2("Please select images first.");
            return;
        }
        try {
            const uploadedUrls = [];

            for (const image of images2) {
                const formData = new FormData();
                formData.append("image", image);
                formData.append("imageName", image.name);

                const res = await TrainerRegistrationService.uploadImage(formData);
                uploadedUrls.push(res.url); // Assuming response contains the uploaded URL
            }
            setImagesList2((prev) => [...prev, ...uploadedUrls]); // Add to array
            alert(" uploaded successfully");
        } catch (error) {
            console.error("Error uploading images:", error);
            setMessage1("An error occurred while uploading the images.");
        }


    };
    const removeImage = (index, imageURL) => {
        TrainerRegistrationService.deleteAzureImage({ "imageURL": imageURL }).then((res) => {
            const updatedList = [...imageslist1];
            updatedList.splice(index, 1);
            setImagesList(updatedList);
        }).catch((err) => {
        });
    };
    const formik = useFormik({
        initialValues: trainerRegistration,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.schooleId = userDetails.schooleId;
            
            if (trainerRegistration._id) {
                // Update case: set profile if imageslist2 has a value
                if (imageslist2.length > 0) {
                    values.profile = imageslist2[0];
                } else {
                    // If no new image uploaded, keep existing profile or set to empty
                    values.profile = trainerRegistration.profile || '';
                }
                
                TrainerRegistrationService.upadeTrainerRegistration(values).then((res) => {
                    handleClose();
                    getTrainerRegistrationList();
                    resetForm()
                    setIsEditMode(false);
                    setImagesList2([]);
                    alert("Trainer Updated Successfully.");
                }).catch((err) => {
                    console.error(err);
                });
            }
            else {
                // Create case: set profile if imageslist2 has a value
                values.profile = imageslist2.length > 0 ? imageslist2[0] : '';

                TrainerRegistrationService.creteTrainerRegistration(values).then((res) => {
                    getTrainerRegistrationList();
                    resetForm();
                    handleClose();
                    setImagesList2([]);
                    alert(" Trainer Added Successfully.");
                    // props.history.push('/app/vendor');
                })
                    .catch((err) => {
                        alert(err.response.data.message)
                    })
            }

        },
    });

    return (

        <>
            <PageTitle title="Trainer Registration" button={<Button
                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Create Trainer Registration
            </Button>} />

            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                <TableContainer component={Paper} style={{ maxHeight: 500 }}>

                        <Table stickyHeader className="mb-0">
                            <TableHead >
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {trainerRegistrationList.map((trainerRegistration) => (
                                    <TableRow key={trainerRegistration._id}>
                                        <TableCell className="pl-3 fw-normal">
                                            {trainerRegistration.profile ? (
                                                <img
                                                    src={trainerRegistration.profile}
                                                    alt="trainerRegistration"
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = ''; // Clear src to trigger fallback
                                                    }}
                                                    style={{
                                                        width: '40px',
                                                        height: '40px',
                                                        borderRadius: '50%',
                                                        objectFit: 'cover',
                                                    }}
                                                />
                                            ) : (
                                                <AccountCircleIcon style={{ fontSize: 40, color: '#999' }} />
                                            )}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal" >{trainerRegistration.name}</TableCell>

                                        <TableCell className="pl-3 fw-normal" >{trainerRegistration.mobileNumber}</TableCell>

                                        <TableCell className="pl-3 fw-normal" >{trainerRegistration.email}</TableCell>




                                        <TableCell>
                                            <EditIcon style={{ cursor: 'pointer' }} onClick={() => editTrainerRegistration(trainerRegistration)} >
                                            </EditIcon >
                                        </TableCell>
                                        <TableCell>
                                            <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteTrainerRegistration(trainerRegistration)} />
                                        </TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        </TableContainer>
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add Trainer</DialogTitle>
                <form onSubmit={formik.handleSubmit} >
                    <DialogContent style={{ width: 308 }}>

                        <TextField
                            InputProps={{ style: { width: 258 } }}
                            autoFocus
                            margin="dense"
                            id="name"
                            name="name"
                            label="Trainer Name"
                            type="text"
                            variant="standard"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            error={formik.touched.name && Boolean(formik.errors.name)}
                            helperText={formik.touched.name && formik.errors.name}
                        />


                        <TextField
                            InputProps={{ style: { width: 258 } }}
                            margin="dense"
                            id="mobileNumber"
                            name="mobileNumber"
                            label="Mobile Number"
                            type="text"
                            variant="standard"

                            value={formik.values.mobileNumber}
                            onChange={formik.handleChange}
                            error={formik.touched.mobileNumber && Boolean(formik.errors.mobileNumber)}
                            helperText={formik.touched.mobileNumber && formik.errors.mobileNumber}

                        />
                        <Grid item xs={12} style={{ marginTop: '30px' }}>
                            <span style={{ fontSize: '17px', color: '#1a1a1aad', }} >Uplaod Trainer Profile:</span>
                        </Grid>

                        <Grid item xs={6}>
                            <input
                                type="file"
                                accept="image/*"
                                // Enable multiple file selection
                                onChange={handleFileChange2}
                            />
                            <br></br>
                            <br></br>
                            <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white', border: 'none' }} onClick={handleUpload2}>Uplaod </Button>

                            {imageslist2.length > 0 && (
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                                    {imageslist2.map((url, index) => (
                                        <div key={index} style={{ position: 'relative' }}>
                                            <img
                                                key={index}
                                                src={url}
                                                alt={`Uploaded ${index + 1}`}
                                                style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                            />
                                            <Button
                                                size="small"
                                                onClick={() =>
                                                    setImagesList2((prev) => prev.filter((_, i) => i !== index))
                                                }
                                                style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    right: 0,
                                                    backgroundColor: "white",
                                                    border: "none",
                                                    cursor: "pointer",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                ❌
                                            </Button>
                                        </div>

                                    ))}
                                </div>
                            )}
                        </Grid>
                        <TextField
                            InputProps={{ style: { width: 258 } }}
                            margin="dense"
                            id="email"
                            name="email"
                            label="Email ID"
                            type="text"
                            variant="standard"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                        />





                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit" onClick={verifyeetnt}>Add</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}


